export default __webpack_public_path__ + "static/media/phone-solid.25e6f1e7.svg";